import { render } from "./ManageVolumes.vue?vue&type=template&id=6042afcf&scoped=true"
import script from "./ManageVolumes.vue?vue&type=script&lang=js"
export * from "./ManageVolumes.vue?vue&type=script&lang=js"

import "./ManageVolumes.vue?vue&type=style&index=0&id=6042afcf&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6042afcf"]])

export default __exports__